import { RequestFormState } from '../../interfaces/RequestForm/RequestFormState';

export default ({ requestForm }: {requestForm: RequestFormState}) => (
	{
		formStatus: requestForm.formStatus,
		formError: requestForm.formError,
		startTime: requestForm.startTime
	});
